export default __webpack_public_path__ + "static/media/gpay.17c583ab.png";